/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { ApiKeyFromJSON, ApiKeyToJSON, GameFromJSON, GameToJSON, SlotFromJSON, SlotToJSON, } from '../models/index';
/**
    * Converts a number to a padded string
    * @param num The number to stringify
    * @param size Number of total digits
    */
function pad(num, size) {
    let negative = num < 0;
    if (negative) {
        num *= -1;
    }
    let numString = num.toString();
    while (numString.length < size)
        numString = "0" + numString;
    return (negative ? "-" : "") + numString;
}
/**
    * Returns a date in the RFC3339 format, e.g.: 2016-01-19T15:21:32.59+02:00
    * @param dateTime
    */
export function toRFC3339(dateTime) {
    let rfcWithoutTimeoffset = `${dateTime.getFullYear()}-${pad(dateTime.getMonth() + 1, 2)}-${pad(dateTime.getDate(), 2)}T${pad(dateTime.getHours(), 2)}:${pad(dateTime.getMinutes(), 2)}:${pad(dateTime.getSeconds(), 2)}${dateTime.getMilliseconds() != 0 ? "." + pad(dateTime.getMilliseconds(), 3) : ""}`;
    let timeOffsetString;
    let to = dateTime.getTimezoneOffset() * -1;
    let toh = Math.floor(to / 60);
    let tom = to % 60;
    if (tom < 0) {
        tom *= -1;
    }
    timeOffsetString = pad(toh, 2) + ":" + pad(tom, 2);
    return rfcWithoutTimeoffset + (toh > 0 ? "+" : "") + timeOffsetString;
}
/**
 *
 */
export class GamesApi extends runtime.BaseAPI {
    /**
     * Requests a single game. Will return said game
     */
    async gameGameIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters['gameId'] == null) {
            throw new runtime.RequiredError('gameId', 'Required parameter "gameId" was null or undefined when calling gameGameIdGet().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/game/{gameId}`.replace(`{${"gameId"}}`, encodeURIComponent(String(requestParameters['gameId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GameFromJSON(jsonValue));
    }
    /**
     * Requests a single game. Will return said game
     */
    async gameGameIdGet(requestParameters, initOverrides) {
        const response = await this.gameGameIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Generates a new api key for a game. Will only work for owners
     */
    async gameGameIdKeyApiKeyIdInvalidatePutRaw(requestParameters, initOverrides) {
        if (requestParameters['gameId'] == null) {
            throw new runtime.RequiredError('gameId', 'Required parameter "gameId" was null or undefined when calling gameGameIdKeyApiKeyIdInvalidatePut().');
        }
        if (requestParameters['apiKeyId'] == null) {
            throw new runtime.RequiredError('apiKeyId', 'Required parameter "apiKeyId" was null or undefined when calling gameGameIdKeyApiKeyIdInvalidatePut().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/game/{gameId}/key/{apiKeyId}/invalidate`.replace(`{${"gameId"}}`, encodeURIComponent(String(requestParameters['gameId']))).replace(`{${"apiKeyId"}}`, encodeURIComponent(String(requestParameters['apiKeyId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Generates a new api key for a game. Will only work for owners
     */
    async gameGameIdKeyApiKeyIdInvalidatePut(requestParameters, initOverrides) {
        await this.gameGameIdKeyApiKeyIdInvalidatePutRaw(requestParameters, initOverrides);
    }
    /**
     * Generates a new api key for a game. Will only work for owners
     */
    async gameGameIdKeyGeneratePostRaw(requestParameters, initOverrides) {
        if (requestParameters['gameId'] == null) {
            throw new runtime.RequiredError('gameId', 'Required parameter "gameId" was null or undefined when calling gameGameIdKeyGeneratePost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/game/{gameId}/key/generate`.replace(`{${"gameId"}}`, encodeURIComponent(String(requestParameters['gameId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ApiKeyFromJSON(jsonValue));
    }
    /**
     * Generates a new api key for a game. Will only work for owners
     */
    async gameGameIdKeyGeneratePost(requestParameters, initOverrides) {
        const response = await this.gameGameIdKeyGeneratePostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Requests all api keys for a game. Will only work for owners
     */
    async gameGameIdKeysGetRaw(requestParameters, initOverrides) {
        if (requestParameters['gameId'] == null) {
            throw new runtime.RequiredError('gameId', 'Required parameter "gameId" was null or undefined when calling gameGameIdKeysGet().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/game/{gameId}/keys`.replace(`{${"gameId"}}`, encodeURIComponent(String(requestParameters['gameId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiKeyFromJSON));
    }
    /**
     * Requests all api keys for a game. Will only work for owners
     */
    async gameGameIdKeysGet(requestParameters, initOverrides) {
        const response = await this.gameGameIdKeysGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates a new slot for this game
     */
    async gameGameIdSlotPostRaw(requestParameters, initOverrides) {
        if (requestParameters['gameId'] == null) {
            throw new runtime.RequiredError('gameId', 'Required parameter "gameId" was null or undefined when calling gameGameIdSlotPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/game/{gameId}/slot`.replace(`{${"gameId"}}`, encodeURIComponent(String(requestParameters['gameId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SlotToJSON(requestParameters['slot']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => SlotFromJSON(jsonValue));
    }
    /**
     * Creates a new slot for this game
     */
    async gameGameIdSlotPost(requestParameters, initOverrides) {
        const response = await this.gameGameIdSlotPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async gamesGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/games`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GameFromJSON));
    }
    /**
     */
    async gamesGet(initOverrides) {
        const response = await this.gamesGetRaw(initOverrides);
        return await response.value();
    }
}
